import HttpService from './HttpService';
export default class StudyConfigurationService {
  constructor() {
    this._httpService = new HttpService();
  }

  async FindAll(personType) {
    return await this._httpService.get('/api/salesforce/study_configuration', { personType });
  }
}
